import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installations-custom',
  templateUrl: './installations-custom.component.html',
  styleUrls: ['./installations-custom.component.scss']
})
export class InstallationsCustomComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  sortby(column: string): void{
    console.log('Tri par la colonne '+ column);
  }

}
